import { put, takeLatest } from 'redux-saga/effects'
import { getType } from 'typesafe-actions'
import { loadUserInfo, setUserInfo } from 'redux/actions'
import { get } from 'shared/api/api'
import { parseJwt } from 'shared/utils'

const isAdmin = (uid: string) => !/^[a-zA-Z]\d/i.test(uid)

function* loadUserInfoSaga(action: ReturnType<typeof loadUserInfo.request>) {
    try {
        const authData = yield get({
            url: '/api/auth',
            headers: {
                authorizationcode: action.payload
            }
        })
        const { access_token, refresh_token } = authData
        if (access_token) {
            localStorage.setItem('accessToken', access_token)
            localStorage.setItem('refreshToken', refresh_token)
            const { commercialSuppliers, preferred_username } = parseJwt(access_token)
            yield put(
                loadUserInfo.success({
                    isAdmin: isAdmin(preferred_username),
                    subtitle: preferred_username,
                    suppliers: commercialSuppliers.map((e: string) => e.trim()),
                    token: access_token
                })
            )
        }
    } catch (e) {
        console.log(e)
    }
}

function* setUserInfoSaga(action: ReturnType<typeof setUserInfo>) {
    try {
        const { commercialSuppliers, preferred_username } = parseJwt(action.payload)

        yield put(
            loadUserInfo.success({
                isAdmin: isAdmin(preferred_username),
                subtitle: preferred_username,
                suppliers: commercialSuppliers,
                token: action.payload
            })
        )
    } catch (e) {
        console.log(e)
    }
}

export const userSaga = [
    takeLatest(getType(loadUserInfo.request), loadUserInfoSaga),
    takeLatest(getType(setUserInfo), setUserInfoSaga)
]
